import gql from 'graphql-tag';

export const DELETE_MISSION_ITEM_MUTATION = gql`
  mutation DeleteMissionItem($missionItemId: ID!) {
    deleteMissionItem(where: { id: $missionItemId }) {
      id
    }
  }
`;
